import { TSDCustomsLog, TSDData } from '@e-origin/contracts';
import { CustomsStateNotificationType, StatusReasonCode, TSDBusinessValidationType, TSDStatus, TSDType } from '@e-origin/shared';

export const getStatusLabel = (status: TSDStatus | undefined): string => {
  const statuses = new Map<TSDStatus, string>([
    [TSDStatus.NOT_SENT, 'Not sent'],
    [TSDStatus.SENDING, 'Sending'],
    [TSDStatus.SENT, 'Sent'],
    [TSDStatus.PRELODGED, 'Pre-lodged'],
    [TSDStatus.ACCEPTED, 'Accepted'],
    [TSDStatus.INVALIDATED, 'Invalidated'],
    [TSDStatus.UNDER_CONTROL, 'Under control'],
    [TSDStatus.IRREGULARITY_UNDER_INVESTIGATION, 'Irregularity under investigation'],
    [TSDStatus.MEASURES_REQUIRED, 'Measures required'],
    [TSDStatus.TEMPORARY_STORAGE_ENDED, 'Temporary storage ended'],
    [TSDStatus.REJECTED, 'Rejected'],
    [TSDStatus.CLEARED, 'Cleared'],
    [TSDStatus.PRESENTED, 'Presented'],
    [TSDStatus.LINKED, 'Linked'],
    [TSDStatus.NOT_LINKED, 'Not linked'],
  ]);

  return statuses.get(status) || 'Unknown status';
};

export const getControlStatusReason = (statusReasonCode: StatusReasonCode): string => {
  const reasons = new Map<StatusReasonCode, string>([
    [StatusReasonCode.AMENDMENT_IRREGULARITY, 'Amendment irregularity'],
    [StatusReasonCode.LOCATION_OF_GOODS_TYPE_D, 'Location of goods type D'],
    [StatusReasonCode.CUSTOMS_CONTROL_FOUND_IRREGULARITIES, 'Customs control found irregularities'],
    [StatusReasonCode.CUSTOMS_OFFICER_REFUSED_IRREGULARITY, 'Customs officer refused the irregularity — corrective measures required'],
    [StatusReasonCode.CUSTOMS_DECIDED_TO_END_TEMPORARY_STORAGE, 'Customs decided to end temporary storage'],
    [StatusReasonCode.STORAGE_DEADLINE_PASSED_GOODS_NOT_FULLY_CLEARED, 'Storage deadline passed — goods not fully cleared'],
    [StatusReasonCode.STORAGE_DEADLINE_PASSED_WHILE_IRREGULARITY_OPEN, 'Storage deadline passed while an irregularity was open'],
  ]);
  return reasons.get(statusReasonCode) || 'Unknown reason';
};

export const shouldShowForTypes = (tsdView: TSDType, allowedTypes: TSDType[]): boolean => {
  return allowedTypes.includes(tsdView);
};

export const countCustomsStateNotifications = (tsd: TSDData): { notificationsPending: number } => {
  const notificationsPending =
    tsd.customsState?.notifications?.filter(({ notificationType, read }) => notificationType === CustomsStateNotificationType.NOTIFICATION_PENDING && !read)
      .length ?? 0;

  return { notificationsPending };
};

export const getLastMessageCode = (customsLogs: TSDCustomsLog[]): string | null => {
  if (customsLogs.length === 0) {
    return null;
  }
  const lastLog = customsLogs.pop();
  return lastLog?.customsMessageCode !== 'sent' ? lastLog?.customsMessageCode : null;
};

export const canEditTsdAfterPresentationNotificationFailure = ({
  status,
  businessValidationType,
}: {
  status?: TSDStatus;
  businessValidationType?: TSDBusinessValidationType;
}): boolean => {
  if (!status || !businessValidationType) {
    return false;
  }

  const isPrelodged = status === TSDStatus.PRELODGED;

  const isRejectedAfterPrelodged = status === TSDStatus.REJECTED && businessValidationType === TSDBusinessValidationType.PRELODGED;

  const isNotLinkedAfterPresentationNotification =
    status === TSDStatus.NOT_LINKED && businessValidationType === TSDBusinessValidationType.PRESENTATION_NOTIFICATION;

  return isPrelodged || isRejectedAfterPrelodged || isNotLinkedAfterPresentationNotification;
};
